import reducer, * as reducers from './eventsReducer';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';

export default {
  reducer,
  actions,
  actionTypes,
  reducers,
  selectors,
};
